import { ISSUES_BASE_PATH, type IssuesTab } from '@/constant/issues'
import { Navigate, useLocation } from 'react-router'

/** Redirects the legacy /non-conformity and /opportunity-for-improvement pages, keeping any query string */
const LegacyIssuesRedirect = ({ tab }: { tab: IssuesTab }) => {
  const { search } = useLocation()
  return <Navigate to={{ pathname: `${ISSUES_BASE_PATH}/${tab}`, search }} replace />
}

export default LegacyIssuesRedirect
